import { render, staticRenderFns } from "./count.vue?vue&type=template&id=2adee784&"
import script from "./count.vue?vue&type=script&lang=js&"
export * from "./count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2adee784')) {
      api.createRecord('2adee784', component.options)
    } else {
      api.reload('2adee784', component.options)
    }
    module.hot.accept("./count.vue?vue&type=template&id=2adee784&", function () {
      api.rerender('2adee784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/count.vue"
export default component.exports